import { InputAdornment, makeStyles, TextField } from "@material-ui/core";
import { FieldConfig } from "formik";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";

interface Props extends FieldConfig {
  label?: string;
  multiline?: boolean;
  rows?: number;
  dir?: string;
  placeholder?: string;
  disabled?: boolean;
  prefix?: string;
  suffix?: string;
  disablePerformance?: boolean;
  loading?: boolean;
  className?: string;
  onChange: (val: string) => any;
  borderStyles?: string | undefined;
}

const useStyles = makeStyles({
  container: { display: "flex", flexDirection: "column", width: "100%" },
  inputField: {
    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
    borderRadius: "6px",
    height: "38px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
  },
  textArea: {
    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
    borderRadius: "6px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
  },
  notchedOutline: { borderColor: "#D1D5DB" },
  label: {
    fontFamily: "Dubai",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#374151",
  },
});
const QPRInputField = (props: Props) => {
  const classes = useStyles();
  const ctx = useAppContext();

  function pickClassName() {
    if (props.className) {
      return props.className;
    }
    if (props.multiline) {
      return classes.textArea;
    }
    return classes.inputField;
  }
  return (
    <div className={classes.container}>
      <p className={classes.label} dir={ctx.rtl ? "rtl" : "ltr"}>
        {props.label}
      </p>
      <TextField
        dir={ctx.rtl ? "rtl" : "ltr"}
        InputProps={{
          classes: {
            root: pickClassName(),
            notchedOutline: props.borderStyles || classes.notchedOutline,
          },
          startAdornment: props.prefix && (
            <InputAdornment position="start">{props.prefix}</InputAdornment>
          ),
          endAdornment: props.suffix && (
            <InputAdornment position="end">{props.suffix}</InputAdornment>
          ),
        }}
        fullWidth
        variant="outlined"
        {...props}
        onChange={(ev) => props.onChange(ev.target.value)}
        label=""
      />
    </div>
  );
};

export default React.memo(QPRInputField);
